import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { WorkflowList } from '@/features/workflows'
import { VoiceInputProvider } from '@workspace/ui/components/voice-input-context'

const workflowsSearchSchema = z.object({
  search: z.string().optional().catch(''),
  category: z.string().optional().catch(''),
  status: z.string().optional().catch(''),
})

function WorkflowListPage() {
  return (
    <VoiceInputProvider enabled={false}>
      <WorkflowList />
    </VoiceInputProvider>
  )
}

export const Route = createFileRoute(
  '/_authenticated/_organization/workflows/'
)({
  component: WorkflowListPage,
  validateSearch: workflowsSearchSchema,
})
